import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { EmployeeComponent } from './employee.component';

/**
 * コープデリ職員初期表示画面 モジュール設定クラス
 *
 * @export EmployeeModule
 * @class EmployeeModule
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    EmployeeComponent,
  ]
})
export class EmployeeModule {

}
